export const AppRoutesEnum = {
    BASE: '',

    ERROR: '/error',

    DASHBOARD: '/checkmate/automated-genotyping/listing',

    ACCOUNT_OVERVIEW: '/accounts/user/overview',
    ACCOUNT_CONTACTS: '/accounts/user/contacts',
    ACCOUNT_DISCOUNTS: '/accounts/user/discounts',
    ACCOUNT_MESSAGES: '/accounts/user/messages',
    ACCOUNT_MODIFY: '/accounts/user/modify',
    ACCOUNT_NOTES: '/accounts/user/notes',
    ACCOUNT_ROLES: '/accounts/user/roles',
    ACCOUNT_LISTING: '/accounts/listing',

    STRAINS: '/strains',
    STRAIN_OVERVIEW: '/strains/strain/overview',
    STRAIN_AIM: '/strains/strain/aim',
    STRAIN_MESSAGES: '/strains/strain/messages',
    STRAIN_NOTES: '/strains/strain/notes',
    STRAIN_RESULTS_VALIDATION: '/strains/strain/results-validation',
    STRAIN_TRANSLATIONS: '/strains/strain/translations',
    STRAIN_SIF: '/strains/strain/sif',
    STRAIN_LISTING: '/strains/listing',
    STRAIN_COPY: '/strains/copy',

    ASSAY_OVERVIEW: '/assays/assay/overview',
    ASSAY_MODIFY_DETAILS: '/assays/assay/modify-details',
    ASSAY_PROBES: '/assays/assay/probes',
    ASSAY_CROSSES: '/assays/assay/crosses',
    ASSAY_MUTATIONS: '/assays/assay/mutations',
    ASSAY_DOCS: '/assays/assay/docs',
    ASSAY_DATABASES: '/assays/assay/databases',
    ASSAY_NOTES: '/assays/assay/notes',
    ASSAY_LOG: '/assays/assay/log',
    ASSAY_SIF: '/assays/assay/sif',
    ASSAY_ORDER_PCR_PRODUCT: '/assays/order-pcr-product',

    ASSAYS: '/assays',
    ASSAY_LISTING: '/assays/listing',
    ASSAY_PROBE_MANUFACTURING: '/assays/probe-manufacturing',
    ASSAY_SEQUENCING: '/assays/sequencing',
    ASSAY_CONSTRUCTS: '/assays/constructs',
    ASSAY_CONSTRUCT_OVERVIEW: '/assays/construct/overview',
    ASSAY_CONSTRUCT_STRAINS: '/assays/construct/strains',

    CKM_LISTING: '/checkmate/automated-genotyping/listing',
    CKM_DETAILS: '/checkmate/automated-genotyping/details',
    CKM_SETUP: '/checkmate/automated-genotyping/setup',

    SEQ_CKM_RETEST_LISTING: '/checkmate/sequencing/listing',
    SEQ_CKM_RETEST_SETUP: '/checkmate/sequencing/setup',
    SEQ_LISTING: '/sequencing/order-retest/listing',
    SEQ_SETUP: '/sequencing/setup',
    SEQ_ORDERS_SETUP: '/sequencing/orders/setup',
    SEQ_ORDERS_LIST: '/sequencing/orders/list',
    SEQ_ORDERS_REACTIONS_LIST: '/sequencing/orders/list/reactions',
    SEQ_ORDERS_ABSTRACT_DETAILS: (id: number) => `/sequencing/orders/details/${id}`,
    SEQ_ORDERS_ABSTRACT_RESULTS: (id: number) => `/sequencing/orders/details/${id}/results`,
    SEQ_BANNER_MANAGEMENT: '/sequencing/banner-management',
    SEQ_SAMPLE_MANAGEMENT: '/sequencing/sample-management',
    SEQ_PRIMER_MANAGEMENT: '/sequencing/primer-management',
    SEQ_PRIMER_MANAGEMENT_INVENTORY: '/sequencing/primer-management/inventory',
    SEQ_PRIMER_MANAGEMENT_CUSTOM_PRIMER_QUEUE: '/sequencing/primer-management/custom-queue',
    SEQ_PRIMER_MANAGEMENT_CURRENT_ORDERS: '/sequencing/primer-management/current-orders',

    PROBES: '/probes',
    PROBE_LISTING: '/probes/listing',
    PROBE_MANUFACTURING: '/probes/probe-manufacturing',
    PROBE_OVERVIEW: '/probes/probe/overview',
    PROBE_MODIFY_DETAILS: '/probes/probe/modify-details',
    PROBE_INCOMPATIBLE: '/probes/incompatible-probes',
    PROBE_REDESIGN: '/probes/probe/redesign',
    PROBE_ORDER_HISTORY: '/probes/probe/order-history',
    PROBE_ORDER_SEQUENCING: '/probes/probe/sequencing',
    PROBE_STRAINS: '/probes/probe/strains',
    PROBE_SCHEDULE_RETRESTS: '/probes/probe/schedule-retests',
};
